'use client';

import { Box, Typography, Grid } from '@mui/material';
import { BlogCard } from './BlogCard';
import type { BlogPostMeta } from '../lib/posts';

interface RelatedPostsProps {
  posts: BlogPostMeta[];
  title?: string;
}

/**
 * RelatedPosts - Displays a grid of related blog post cards.
 */
export function RelatedPosts({
  posts,
  title = 'Related Posts',
}: RelatedPostsProps) {
  if (posts.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mt: 6 }}>
      <Typography
        variant="h5"
        component="h2"
        sx={{ fontWeight: 600, mb: 3 }}
      >
        {title}
      </Typography>
      <Grid container spacing={3}>
        {posts.map((post) => (
          <Grid key={post.slug} size={{ xs: 12, md: 4 }}>
            <BlogCard post={post} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
